<mat-card class="job-code-card">
  <mat-card-header>
    <mat-card-title>
      <mat-icon>{{ profile?.icon }}</mat-icon>
      <h4 class="bold">{{ profile?.type }}</h4>
    </mat-card-title>
    <div class="buttons">
      @if (!mercerSupportDetailsService.isReadOnly) {
        @if (isInEditMode$ | async) {
          <coin-v2-button
            type="outline"
            icon="close"
            iconPos="left"
            [disabled]="fetchingData$ | async"
            [text]="'general.btnClose' | translate"
            (click)="cancel()"></coin-v2-button>
          @if (!isCareerLevel && !hideNextButton) {
            <coin-v2-button
              type="primary"
              icon="navigate_next"
              iconPos="left"
              [disabled]="!profileTitle || (fetchingData$ | async)"
              [text]="'general.next' | translate"
              (click)="goToNextProfile()"></coin-v2-button>
          }
          @if (isCareerLevel) {
            <coin-v2-button
              type="primary"
              icon="save"
              iconPos="left"
              [disabled]="isJobCodeSaveButtonDisabled || (fetchingData$ | async)"
              [text]="'general.btnSave' | translate"
              (click)="save()"></coin-v2-button>
          }
        }
        @if (!(isInEditMode$ | async) && isEditButtonVisible) {
          <coin-v2-button
            icon="edit"
            iconPos="left"
            type="primary"
            [disabled]="!isEditable || (fetchingData$ | async)"
            [text]="'general.edit' | translate"
            (click)="edit()"></coin-v2-button>
        }
      }
    </div>
  </mat-card-header>
  @if (mercerData) {
    <mat-card-content [class.editable]="isInEditMode$ | async">
      @if (isInEditMode$ | async) {
        <div class="selections">
          <coin-v2-text-input
            ngModel
            matFormFieldClass="shadow"
            [placeholder]="'general.search' | translate"
            (ngModelChange)="search$.next($event)" />
          <div
            class="selection-items"
            infiniteScroll
            [infiniteScrollThrottle]="50"
            [scrollWindow]="false"
            (scrolled)="onScroll()">
            @for (selection of profileSelections; track selection?.title || selection) {
              <coin-v2-selectable-card
                #cardComponent="ngModel"
                animate.enter="fade-in"
                animate.leave="fade-out"
                rounding="extra-large"
                [ngModel]="selection.title === profileTitle"
                (ngModelChange)="onSelectionToggle(selection, cardComponent)">
                <div class="text">
                  <h4>{{ selection?.title | translate }}</h4>
                  @if (selection?.description) {
                    <p>{{ selection.description | translate }}</p>
                  }
                </div>
              </coin-v2-selectable-card>
            }
          </div>
        </div>
      } @else {
        <p class="bold">{{ profileTitle }}</p>
        @for (part of descriptionParts; track part) {
          <div>
            <p>
              {{ part }}
            </p>
          </div>
        }
      }
    </mat-card-content>
  }
</mat-card>
